import PropertyBidCard from "@/Components/PropertyBigCard"
import { useAppSelector } from "@/store/hooks"
import { allPieces } from "@/utils/data"
import { mapDesigns } from "@mono/mapDesigns"

export const AuctionTiedNotification: React.FC<
  AuctionTiedNotificationProps
> = ({ propertyOrder }) => {
  const myGameSettings = useAppSelector((state) => state.global.myGame?.settings)

  const myMap = mapDesigns.find(
    (map) => map.id === myGameSettings?.mapId
  )
  const cell = myMap?.cells.find((cell) => cell.order === propertyOrder)
  // const propertywon = getcellbymapidandorder(
  //   state.mygame?.settings.mapid as string,
  //   propertyorder
  // )
  return (
    <>
      <div
        data-testid="notification.auction-won"
        className="fixed top-1/2 left-1/4 z-[100] -translate-y-1/2 -translate-x-full auction-won-card-pop-out"
      >
        <PropertyBidCard cell={cell as ICell}></PropertyBidCard>
      </div>
      <div className="fixed top-1/2 items-center gap-5 -translate-y-1/2 w-full py-10 font-semibold shadow-centerCardGlow border-auction-activeBorderColor border-t-4 border-b-4 flex justify-center text-5xl z-20 text-white font-poppins bg-[rgba(0,0,0,0.8)] auction-won-banner-pop-out">
        Auction Tied. Property not sold.
      </div>
    </>
  )
}
